import { useTranslation } from 'react-i18next'
import contentData from '../../data/content.json'
import RichText from '../ui/RichText'

function About() {
  const { t } = useTranslation()

  return (
    <section className="section-container bg-white py-80">
      <div className="content-wrapper">
        <h2 className="text-lato-bold text-[32px] mb-32">
          {t('pages.home.sections.about.heading')}
        </h2>
        <div className="flex flex-col tablet:flex-row gap-40 tablet:gap-60 items-start">
          {/* Text */}
          <div className="flex-1">
            <RichText
              text={t('pages.home.sections.about.text')}
              className="text-lato-regular"
            />
          </div>

          {/* Photo */}
          <div className="flex-1">
            <img
              src={contentData.images.aboutPhoto.url}
              alt={contentData.images.aboutPhoto.alt}
              className="w-full h-auto max-h-[480px] object-cover rounded-md"
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
